import { render, staticRenderFns } from "./ManageCoursePriceAndLearnDurationForm.vue?vue&type=template&id=14577f3c"
import script from "./ManageCoursePriceAndLearnDurationForm.vue?vue&type=script&lang=js"
export * from "./ManageCoursePriceAndLearnDurationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports